module.exports = __webpack_public_path__ + "static/media/delete.609b3382.svg";